// extracted by mini-css-extract-plugin
export default {"pageWrapper":"pageWrapper__pageWrapper___BCmNu"};